import { TaxRatePermissions } from './tax-rates.permissions';
import { TaxRateRoles } from './tax-rates.roles';

export const taxRateMappings = {
  [TaxRatePermissions.GET_TAX_RATES]: [TaxRateRoles.VIEWER],
  [TaxRatePermissions.PERSIST_TAX_RATE]: [TaxRateRoles.PERSISTER],
  [TaxRatePermissions.DELETE_TAX_RATE]: [TaxRateRoles.DELETER],
};
